var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEp3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.707 2.78613V30.6467",
    stroke: "#C49A6C",
    strokeWidth: 2.78605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6709 6.96533H13.2232C11.9302 6.96533 10.69 7.47901 9.77568 8.39336C8.86133 9.30771 8.34766 10.5478 8.34766 11.8409C8.34766 13.134 8.86133 14.3741 9.77568 15.2885C10.69 16.2028 11.9302 16.7165 13.2232 16.7165H20.1884C21.4815 16.7165 22.7216 17.2302 23.6359 18.1445C24.5503 19.0589 25.064 20.299 25.064 21.5921C25.064 22.8852 24.5503 24.1253 23.6359 25.0397C22.7216 25.954 21.4815 26.4677 20.1884 26.4677H8.34766",
    stroke: "#C49A6C",
    strokeWidth: 2.78605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEp3);
export default __webpack_public_path__ + "static/media/EP3.022e46689bfd74acc2f2ed3aeb575f4f.svg";
export { ForwardRef as ReactComponent };